// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"lP-z","inlineTitle":"mP-z","sponsoredAdsWrapper":"nP-z","marketplaceRecosWrapper":"oP-z"};